/* Moment */
import moment from "moment"


/* The states of a code — the server counts them, the panel only names them */
export const STATES = {
    active: { text: "Работает", hint: "Точка может ввести код при открытии", accent: "green" },
    inactive: { text: "Выключен", hint: "Код отвечает форме как незнакомый", accent: "grey" },
    expired: { text: "Истёк", hint: "Последний день кода уже прошёл", accent: "orange" },
    exhausted: { text: "Исчерпан", hint: "Все использования кода разобраны", accent: "violet" }
}

export const stateOf = key => {

    if (STATES[key]) {
        return STATES[key]
    }

    return STATES.inactive
}

/* The tabs of the page in their order */
export const TABS = ["active", "inactive", "expired", "exhausted"]

/* The terms a code is usually given — one press instead of typing */
export const TERMS = [1, 2, 3, 6, 12, 24]

/* "1 месяц", "3 месяца", "12 месяцев" */
export const monthsText = value => {

    const number = Math.abs(parseInt(value)) || 0
    const tens = number % 100
    const units = number % 10

    if (tens > 10 && tens < 20) {
        return `${number} месяцев`
    }

    if (units === 1) {
        return `${number} месяц`
    }

    if (units >= 2 && units <= 4) {
        return `${number} месяца`
    }

    return `${number} месяцев`
}

/* How many times the code was used out of how many it may be */
export const usesText = item => {

    if (item.maxUses === null || item.maxUses === undefined) {
        return `${item.usedCount} из ∞`
    }

    return `${item.usedCount} из ${item.maxUses}`
}

/* The last day of the code */
export const untilText = value => {

    if (!value) {
        return "Бессрочно"
    }

    return `до ${moment(value).format("D MMMM YYYY")}`
}
